import {
  LANGUAGE_FLAG,
  LANGUAGE_LABEL,
  SUPPORTED_LANGUAGES,
  type Language,
} from '@pharmaconnect/i18n'
import { useState, useRef, useEffect } from 'react'

import { useTranslation } from '../i18n/I18nProvider'

export function LanguageSwitcher() {
  const { lang, setLang } = useTranslation()
  const [open, setOpen] = useState(false)
  const ref = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false)
      }
    }
    if (open) document.addEventListener('mousedown', handler)
    return () => document.removeEventListener('mousedown', handler)
  }, [open])

  return (
    <div ref={ref} className="relative">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="flex items-center gap-1.5 rounded-md border border-white/10 bg-white/[0.03] px-2 py-1 text-xs text-neutral-300 transition hover:bg-white/10"
        data-testid="language-switcher"
      >
        <span>{LANGUAGE_FLAG[lang]}</span>
        <span className="font-semibold">{lang.toUpperCase()}</span>
        <span className="text-[8px]">▼</span>
      </button>
      {open ? (
        <div className="absolute bottom-full mb-1 left-0 z-50 flex flex-col gap-0.5 rounded-md border border-white/10 bg-black/90 p-1 shadow-lg">
          {SUPPORTED_LANGUAGES.map((l: Language) => (
            <button
              key={l}
              type="button"
              onClick={() => {
                setLang(l)
                setOpen(false)
              }}
              className={`flex items-center gap-2 rounded px-2 py-1 text-xs transition ${
                l === lang
                  ? 'bg-pharmacist/15 text-pharmacist'
                  : 'text-neutral-300 hover:bg-white/10'
              }`}
              data-testid={`language-option-${l}`}
            >
              <span>{LANGUAGE_FLAG[l]}</span>
              <span>{LANGUAGE_LABEL[l]}</span>
            </button>
          ))}
        </div>
      ) : null}
    </div>
  )
}
